// extracted by mini-css-extract-plugin
export default {"materialInput":"materialInput_materialInput__Fzo2A","wrapper":"materialInput_wrapper__22OpW"};